import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { CircularPianoState } from '@/store/types/circular-piano.state';

export const actions: ActionTree<CircularPianoState, RootState> = {
    regenerateRelationArray({ commit, state }) {
        const selectedNote = state.selectedNote;
        const relationArray = [];
        const relNote = state.relationArray[selectedNote];
        for(let i=0; i<24; i++){
            const plus = state.desc ? 0 : 1;
            let note = (selectedNote-11-plus+i)%24;
            note = note < 0 ? note + 24 : note;
            relationArray[note] = relNote-11-plus+i;
        }
        commit('setRelationArray', relationArray);
    },
}